import { useContext } from 'react';
import { AbilityContext } from '../users/UseUserPermissions';

/**
 * useCanReadNotes - CASL gate for reading task notes and review status.
 *
 * Notes/review-status access tier model:
 *   - `manage:notes` (Full Access) → all read + write actions
 *   - `read:notes`   (Read Only)   → can read notes + see review status
 *   - neither (No Access)          → notes section hidden
 *
 * Reads AbilityContext directly so callers that render outside a
 * permissions provider degrade to false rather than throwing.
 */
export const useCanReadNotes = (): boolean => {
  const ctx = useContext(AbilityContext);

  const permissions = ctx?.permissions;
  if (!permissions) return false;
  return permissions.can('manage', 'notes') || permissions.can('read', 'notes');
};
